import React from "react";
import PropTypes from "prop-types";

import Tippy from "@tippy.js/react";
import "tippy.js/dist/tippy.css";
import { StyleWrapper } from "./style";

Tippy.defaultProps = {
  animation: "perspective",
  arrow: true,
  arrowType: "sharp",
  arrowTransform: "scale(0.7)",
  size: "small",
  theme: "astrea",
  delay: 150
};

var Tooltip = function Tooltip(_ref) {
  var title = _ref.title,
      placement = _ref.placement,
      isVisible = _ref.isVisible,
      children = _ref.children,
      theme = _ref.theme,
      maxWidth = _ref.maxWidth;
  return React.createElement(
    StyleWrapper,
    null,
    isVisible ? React.createElement(
      Tippy,
      {
        content: title,
        placement: placement,
        theme: theme,
        maxWidth: maxWidth,
        touchHold: true
      },
      children
    ) : children
  );
};

Tooltip.defaultProps = {
  placement: "bottom",
  isVisible: true,
  theme: "astrea",
  maxWidth: "400px"
};

Tooltip.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  placement: PropTypes.oneOf(["top", "top-start", "bottom", "left", "right"]),
  children: PropTypes.node.isRequired,
  isVisible: PropTypes.bool,
  theme: PropTypes.string,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default Tooltip;